import React from 'react';
import './App.css';
import { Box } from '@mui/material';
import AppBar from './AppBar';
import AppDrawer from './AppDrawer';
import Content from './Content';
import NewUserOnboarding from './components/NewUserOnboarding';

const App: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
      }}
    >
      <AppBar />
      <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        <AppDrawer />
        <Content />
      </Box>
      <NewUserOnboarding />
    </Box>
  );
};

export default App;
